<template>
    <div>
           <component v-for="(item,index) in expList"
                           :is="item.component"
                           :not-first="item.notFirst"
                           :operate="item.operate"
                           :field="item.field"
                           :field-value="item.fieldValue"
                           :input="item.input"
                           :index="index"
                           :is-show-del-btn="isShowDelBtn"
                           :field-list="fieldList"
                           :auto-list="autoList"
                           :maxlength="item.maxlength"
                           :input-type="item.inputType"
                           @key-up-event="handleKeyUpEvent"
                           @query-search="handleQuerySearch"
                           @change-field="handleChangeField"
                           @data-item="handleDataItem"
                           @delete-item="handleDeleteItem"
                           @search-event="handleSearchEvent" ></component>
            <el-button @click="addComponent" size="small"><i class="el-icon-plus"></i> 添加字段</el-button>
    </div>
</template>
<script>
import ipSimpleSearchItem from './IpSimpleSearchConditionItem'
export default {
    name:'ipSimpleSearchCondition',
    props:{
        fieldList:{type:Array,default(){return[]}},
        defaultExp:{type:Array,default(){return[]}},
        autoList:{type:Array,default(){return[]}}
    },
    components:{
        ipSimpleSearchItem
    },
    data(){
        return{
            isShowDelBtn:true,
            expList:[]
        }
    },
    mounted(){
            let tempList = [];
            this.defaultExp.forEach(item=>{
                tempList.push({
                      component:'ip-simple-search-item',
                      notFirst:true,
                      operate:item.operate,
                      field:item.field,
                      fieldValue:item.fieldValue,
                      input:item.input,
                      maxlength:item.maxlength,
                      inputType:item.inputType                
                })
            })
            this.expList = tempList;
            // this.$emit('simple-condition',this.emitList);
    },
    watch:{
        expList(nv,ol){
            nv[0].notFirst = false;
            nv[0].operate = '';
            if(nv.length === 1){
                this.isShowDelBtn = false;
            }else{
                this.isShowDelBtn = true;
            }
        },
        defaultExp(nv,ol){
            let tempList = [];
            nv.forEach(item=>{
                tempList.push({
                      component:'ip-simple-search-item',
                      notFirst:true,
                      operate:item.operate,
                      field:item.field,
                      fieldValue:item.fieldValue,
                      input:item.input,
                      maxlength:item.maxlength,
                      inputType:item.inputType
                })
            })
            this.expList = tempList;
            // this.$emit('simple-condition',this.emitList);
        }
    },
    computed:{
        emitList(){
            let tempList=[];
            this.expList.forEach(item=>{
                tempList.push({
                    field:item.field,
                    fieldValue:item.fieldValue,
                    input:item.input,
                    operate:item.operate,
                })
            })
            return tempList
        }
    },
    methods:{
        handleSearchEvent(item){
            this.$emit('search-event',item);
        },
        handleKeyUpEvent(){
            this.$emit('key-up-event');
        },
        addComponent(){
            this.expList.push({
                component:'ip-simple-search-item',
                notFirst:true,
                operate:'AND',
                field:'',
                fieldValue:'',
                input:'',
                maxlength:255
            })
        },
        handleDataItem(msg){
            this.$set(this.expList[msg.index],'operate', msg.operate);
            this.$set(this.expList[msg.index],'field', msg.field);
            this.$set(this.expList[msg.index],'fieldValue', msg.fieldValue);
            this.$set(this.expList[msg.index],'input', msg.input);
            this.$set(this.expList[msg.index],'maxlength', msg.maxlength);
            this.$emit('simple-condition',this.emitList);
        },
        handleDeleteItem(index){
            if (this.expList.length > 1) {
                this.expList.splice(index,1);
                this.$emit('simple-condition',this.emitList);
            }
        },
        handleChangeField(value){
            this.$emit('change-field',value);
        },
        handleQuerySearch(current){
            this.$emit('query-search',current);
        }
    }
}
</script>
